import React from 'react'
import { View, StyleSheet } from 'react-native'
import { format } from 'date-fns'
import { Icon, Text, useTheme } from '@ui-kitten/components'
import { useTranslation } from 'react-i18next'
import { storesDictAtom, usersDictAtom } from '../../global/AtomsProvider'
import { useAtomValue } from 'jotai'
import { getLocalStoreDate } from '../../utils/timezoneFunctions'
import OperationsList from '../../components/OperationsList'
import { toNestedDate } from '../../utils/nestedDateValue'

export default function UpdatesScreen({ navigation }) {
  const { t } = useTranslation()
  const theme = useTheme()
  const usersDict = useAtomValue(usersDictAtom)
  const storesDict = useAtomValue(storesDictAtom)
  
  const getTypeDetails = (item) => {
    if (item.type === 'deleteProduct') {
      return item.dataBefore?.name
    }
    if (item.type === 'newProduct') {
      return item.dataAfter?.name
    }
    if (item.type === 'updateProductPrices') {
      var message = '' + item.dataAfter.name + ':' + '\n' + t('updates.purchasePrice') + ' - ' + item.dataAfter.purchasePrice + ' (' + item.dataBefore.purchasePrice + ')'+ '\n'
      for (var key in item.dataAfter.salePrices) {
        message += storesDict?.[key]?.name + ' - ' + item.dataAfter.salePrices[key] + ' (' + item.dataBefore.salePrices[key] + ')' + '\n'
      }
      return message
    }
    if (item.type === 'deleteSale') {
      // ATL-916: `dataBefore` is an untouched snapshot, so a date nested inside it arrives as a
      // Firestore Timestamp, as the migration's `{_seconds,_nanoseconds}`, or as the ISO string the
      // live dual-write posts. `.toDate()` exists on only the first, so calling it directly threw
      // and took the whole list down as soon as an org read `updates` from Supabase.
      const saleDate = toNestedDate(item.dataBefore.saleDate)
      const when = saleDate ? format(getLocalStoreDate(item.dataBefore.store, saleDate), "d-M-y HH:mm") : t('updates.unknownDate')
      return (item.dataBefore.store + ', ' + item.dataBefore.finalTotalCartPrice + ', ' + when)
    }
    if (item.type === 'deleteWorkingHour') {
      const workedOn = toNestedDate(item.dataBefore.date)
      const when = workedOn ? format(workedOn, "d-M-y") : t('updates.unknownDate')
      return (usersDict[item.dataBefore.employeeID]?.name + ', ' + storesDict?.[item.dataBefore.store]?.name + ', ' + when + ', ' + item.dataBefore.amount + ' (' + item.dataBefore.employeeBonusAmount + ')')
    }
  }
  
  const renderItemFieldsToShow = (item, date) => {
    return (
      <>
        <View style={styles.dateTimeView}>
          <Icon name='activity-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {t('updates.' + item.type)}
          </Text>
        </View>
        <View style={styles.dateTimeView}>
          <Icon name='message-circle-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {getTypeDetails(item)}
          </Text>
        </View>
        <View style={styles.dateTimeView}>
          <Icon name='clock-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {date}
          </Text>
        </View>
        <View style={styles.dateTimeView}>
          <Icon name='person-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {usersDict[item.cashierUID]?.name}
          </Text>
        </View>
      </>
    )
  }

  return (
    <View style={styles.container}>
      <OperationsList collectionName='updates' dateField={'date'} additionalFilters={null} 
        detailScreenName={null} topView={() => {return null}} initialRange={null}
        showTotalSum={false} totalSumFormatter={null} totalSumField={null}
        showAddButton={false} additionalDataValidation={() => {}} detailScreenParams={{}}
        renderItemFieldsToShow={renderItemFieldsToShow} navigation={navigation} showStoreFilter={true}
        preselectedStore={'all'}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  icon: {
    marginRight: 4,
  },
  itemTitle: {
    marginRight: 25,
  },
  dateTimeView: {
    flexDirection: 'row',
    alignItems: 'center'
  }
});
